import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12cb487b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base leave-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "footer-setting" }

import { getToken } from '@/composables/api/useAuth'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomDisconnectPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  exitPath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props
const router = useRouter()
const leave = async () => {
  if (getToken()) {
    router.go(-1)
  } else {
    window.location.href = props.exitPath
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: _ctx.$t('zoom-diagnostic.disconnect.title'),
    open: __props.modelValue,
    "can-close": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-leave bg-red-500",
          onClick: leave
        }, _toDisplayString(_ctx.$t('zoom-diagnostic.disconnect.leave')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('zoom-diagnostic.disconnect.message')) + " ", 1),
        (!_unref(getToken)())
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.exitPath), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})